import { MediaPlace, RandomPlace } from 'types';

/** What the start script in public/index.html leaves for the app. */
export interface GeoBoot {
  randomPlace: Promise<RandomPlace | null> | null;
  place: Promise<{ mediaId: number; place: MediaPlace } | null> | null;
  dismiss: () => void;
}

declare global {
  interface Window {
    __geoBoot?: GeoBoot;
  }
}

/** The place the start script has drawn: the same one until released. */
export function takeRandomPlace(): Promise<RandomPlace | null> | null {
  return window.__geoBoot?.randomPlace ?? null;
}

/** When going there, so that coming back to the start page draws another. */
export function releaseRandomPlace(): void {
  if (window.__geoBoot) window.__geoBoot.randomPlace = null;
}

/** The data of the place the start script has fetched, if it's this one; once. */
export function takePlace(mediaId: number): Promise<MediaPlace | null> | null {
  const boot = window.__geoBoot;
  if (!boot?.place) return null;
  return boot.place.then((found) => {
    if (found?.mediaId !== mediaId) return null;
    boot.place = null;
    return found.place;
  });
}

/** The start script's photo gives way to the app. */
export function dismissHero(): void {
  window.__geoBoot?.dismiss();
}
